import { CircleDashed } from "@phosphor-icons/react";

import { MobileFiltersDrawer } from "features/filters/components";

import AudienceStateFilterOptions from "../DesktopLayout/AudienceStateFilterOptions";

import type { AudienceStateFilterMenuContentProps } from "../DesktopLayout/AudienceStateFilterMenu";

const STATE_FILTER = {
  state: {
    icon: <CircleDashed weight="fill" />,
    label: "State",
  },
} as const;

export default function MobileFilters({
  selectedStates,
  setSelectedStates,
  audienceWithCancellation,
}: AudienceStateFilterMenuContentProps) {
  const filterMenuProps = {
    selectedStates,
    setSelectedStates,
    audienceWithCancellation,
  };

  return (
    <MobileFiltersDrawer
      title="Filter audience"
      filters={STATE_FILTER}
      getSelectionCount={() => selectedStates.length}
      onClear={(type) => {
        if (type === "all" || type === "state") {
          setSelectedStates([]);
        }
      }}
      renderFilter={() => <AudienceStateFilterOptions {...filterMenuProps} />}
    />
  );
}
